(() => {
 if(customElements.get('mt-wrist-reviews')) return;
 class WristReviews extends HTMLElement {
  connectedCallback(){
   if(this.ready) return; this.ready=true;
   this.data=JSON.parse(this.querySelector('[data-reviews]').textContent);
   this.reviews=this.data.reviews; this.images=this.data.images; this.index=0;
   this.reduce=matchMedia('(prefers-reduced-motion: reduce)');
   this.abort=new AbortController(); const on=(el,event,fn,options={})=>el.addEventListener(event,fn,{...options,signal:this.abort.signal});
   this.dataset.input='pointer';
   on(this,'pointerdown',()=>{this.dataset.input='pointer';},{capture:true,passive:true});
   on(document,'keydown',e=>{if(['Tab','ArrowLeft','ArrowRight'].includes(e.key))this.dataset.input='keyboard';},{capture:true});
   this.stage=this.querySelector('[data-stage]'); this.window=this.querySelector('[data-quote]');
   this.dialog=this.querySelector('dialog');
   this.cards=this.reviews.map((r,i)=>{
    const card=document.createElement('button'); card.type='button'; card.className='mt-wr__card';
    card.setAttribute('aria-label',`View ${r.name}'s review`);
    card.innerHTML=`<img draggable="false" src="${this.images[r.photos[0]]}" alt="${this.esc(r.product)} — photo shared by ${this.esc(r.name)}" width="450" height="430" loading="lazy" decoding="async"><span class="mt-wr__caption"><span>${this.esc(r.name)}</span>${this.stars(r.stars)}</span>`;
    on(card,'click',()=>{if(performance.now()<this.ignoreClickUntil)return; i===this.index?this.open(i):this.go(this.distance(i));});
    this.stage.append(card);return card;
   });
   on(this.querySelector('[data-prev]'),'click',()=>this.go(-1));
   on(this.querySelector('[data-next]'),'click',()=>this.go(1));
   on(this.stage,'keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();this.go(e.key==='ArrowLeft'?-1:1,true);this.cards[this.index].focus({preventScroll:true});}});
   on(this.stage,'pointerdown',e=>{
    if(!e.isPrimary){this.endDrag(true);return;}
    if(e.pointerType==='mouse'&&e.button!==0)return;
    this.drag={id:e.pointerId,x:e.clientX,y:e.clientY,dx:0,axis:null,time:performance.now()};
   });
   on(this.stage,'pointermove',e=>{
    const g=this.drag;if(!g||g.id!==e.pointerId)return;
    const dx=e.clientX-g.x,dy=e.clientY-g.y;
    if(!g.axis&&Math.hypot(dx,dy)>10){
     g.axis=Math.abs(dx)>Math.abs(dy)*1.2?'x':'y';
     this.ignoreClickUntil=performance.now()+800;
     if(g.axis==='x')this.stage.setPointerCapture(e.pointerId);
    }
    if(g.axis!=='x')return;
    g.dx=dx;this.ignoreClickUntil=performance.now()+800;
    this.layout(true,Math.max(-1.35,Math.min(1.35,dx/this.pitch())));
    this.window.style.transform=`translateX(${Math.max(-24,Math.min(24,dx*.12))}px)`;
    this.window.style.opacity=String(1-Math.min(.25,Math.abs(dx)/800));
   });
   on(this.stage,'pointerup',()=>this.endDrag(false));
   on(this.stage,'pointercancel',()=>this.endDrag(true));
   on(this.stage,'lostpointercapture',()=>{if(this.drag)this.endDrag(true);});
   on(this.stage,'dragstart',e=>e.preventDefault());
   on(this.querySelector('[data-close]'),'click',()=>this.dialog.close());
   on(this.dialog,'click',e=>{if(e.target===this.dialog){const b=this.dialog.getBoundingClientRect();if(e.clientX<b.left||e.clientX>b.right||e.clientY<b.top||e.clientY>b.bottom)this.dialog.close();}});
   on(this.dialog,'close',()=>{document.body.style.overflow=this.bodyOverflow;this.lastFocus?.focus({preventScroll:true});});
   this.ro=new ResizeObserver(()=>this.layout(true));this.ro.observe(this.stage);this.ro.observe(this.window);
   this.layout(true);this.renderQuote(false,1);
  }
  esc(s){return s.replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));}
  stars(n){return `<span class="mt-wr__stars" role="img" aria-label="${n} out of 5 stars">${'★'.repeat(n)}${'☆'.repeat(5-n)}</span>`;}
  reviewText(r){return r.text+(r.cut?'…':'');}
  reviewMarkup(r){
   const text=this.reviewText(r),accent=r.emphasis,at=accent?text.indexOf(accent):-1;
   if(at<0)return this.esc(text);
   return this.esc(text.slice(0,at))+'<strong>'+this.esc(accent)+'</strong>'+this.esc(text.slice(at+accent.length));
  }
  pitch(){const w=this.stage.clientWidth;return w<750?Math.min(90,w*.18):Math.min(228,(w-245)/6);}
  endDrag(cancel){
   const g=this.drag;if(!g)return;this.drag=null;
   if(this.stage.hasPointerCapture(g.id))this.stage.releasePointerCapture(g.id);
   this.window.style.transform='';this.window.style.opacity='';
   if(g.axis)this.ignoreClickUntil=performance.now()+800;
   const flick=Math.abs(g.dx)>12&&Math.abs(g.dx)/Math.max(1,performance.now()-g.time)>.45;
   if(!cancel&&g.axis==='x'&&(Math.abs(g.dx)>Math.min(48,this.pitch()*.32)||flick))this.go(g.dx<0?1:-1);
   else this.layout();
  }
  distance(i){const n=this.reviews.length;return ((i-this.index+Math.floor(n/2)+n)%n)-Math.floor(n/2);}
  layout(instant=false,dragOffset=0){
   const mobile=this.stage.clientWidth<750,pitch=this.pitch(),limit=mobile?2:3;
   this.cards.forEach((card,i)=>{
    const d=this.distance(i),visual=d+dragOffset,old=Number(card.dataset.offset??d),hidden=Math.abs(visual)>limit+.95;
    const wrap=Math.abs(d-old)>this.reviews.length/2;
    card.style.transition=(instant||wrap)?'none':'';
    card.style.transform=`translateX(calc(-50% + ${visual*pitch}px)) translateY(${Math.abs(visual)*5}px) rotate(${visual*(mobile?6:4)}deg) scale(${Math.max(.87,1-Math.abs(visual)*.025)})`;
    card.style.opacity=String(Math.max(0,Math.min(1,limit+1-Math.abs(visual))));card.style.zIndex=String(20-Math.round(Math.abs(visual)*2));
    card.style.pointerEvents=hidden?'none':'auto';card.tabIndex=d===0?0:-1;
    card.setAttribute('aria-hidden',String(hidden));card.setAttribute('aria-pressed',String(d===0));card.dataset.offset=d;
   });
   this.positionNavigation();
  }
  positionNavigation(){
   const model=this.window.querySelector('.mt-wr__quote:not([data-outgoing]) .mt-wr__product');
   if(!model)return;
   const review=this.querySelector('.mt-wr__review'),m=model.getBoundingClientRect(),r=review.getBoundingClientRect();
   review.style.setProperty('--mt-wr-nav-y',`${m.top-r.top+m.height/2}px`);
  }
  go(step,instant=false){
   if(!step)return;
   this.index=(this.index+step+this.reviews.length)%this.reviews.length;
   this.layout(instant);this.renderQuote(!instant&&!this.reduce.matches,Math.sign(step));
  }
  renderQuote(animate,dir){
   const r=this.reviews[this.index],old=this.window.querySelector('.mt-wr__quote:not([data-outgoing])');
   this.window.querySelectorAll('[data-outgoing]').forEach(n=>n.remove());
   const article=document.createElement('article');article.className='mt-wr__quote';
   article.innerHTML=`${this.stars(r.stars)}<blockquote>${this.reviewMarkup(r)}</blockquote><p class="mt-wr__byline"><strong>${this.esc(r.name)}</strong><span class="mt-wr__product">${this.esc(r.product)}</span></p><button type="button" class="mt-wr__read">${r.cut?'Read review excerpt':'Read full review'} ↗</button>`;
   article.querySelector('button').onclick=()=>this.open(this.index);
   if(old&&animate){
    old.dataset.outgoing='';old.setAttribute('aria-hidden','true');old.inert=true;
    Object.assign(old.style,{position:'absolute',inset:'0',pointerEvents:'none'});
    old.animate([{opacity:1,transform:'translateX(0)'},{opacity:0,transform:`translateX(${-dir*24}px)`}],{duration:180,easing:'ease-out',fill:'forwards'}).finished.then(()=>old.remove()).catch(()=>old.remove());
   }else old?.remove();
   this.window.append(article);
   this.positionNavigation();
   if(animate)article.animate([{opacity:0,transform:`translateX(${dir*24}px)`},{opacity:1,transform:'translateX(0)'}],{duration:360,easing:'cubic-bezier(.22,.75,.18,1)'});
   this.querySelector('[data-status]').textContent=`Review ${this.index+1} of ${this.reviews.length}: ${r.name}, ${r.stars} out of 5 stars`;
  }
  open(i){
   const r=this.reviews[i];this.lastFocus=document.activeElement;this.bodyOverflow=document.body.style.overflow;
   this.querySelector('[data-detail]').innerHTML=`<div class="mt-wr__photos"><img class="mt-wr__large" src="${this.images[r.photos[0]]}" alt="${this.esc(r.product)} — customer photo">${r.photos.length>1?`<div class="mt-wr__thumbs">${r.photos.map((p,j)=>`<button type="button" aria-label="View photo ${j+1}" aria-pressed="${j===0}" data-photo="${p}"><img src="${this.images[p]}" alt=""></button>`).join('')}</div>`:''}</div><div class="mt-wr__detail-copy">${this.stars(r.stars)}<h3 id="${this.id}-name">${this.esc(r.name)}</h3><p class="mt-wr__product">${this.esc(r.product)}</p><blockquote>${this.reviewMarkup(r)}</blockquote>${r.cut?'<small>Review excerpt.</small>':''}</div>`;
   this.querySelectorAll('[data-photo]').forEach(b=>{b.onclick=()=>{this.querySelector('.mt-wr__large').src=this.images[Number(b.dataset.photo)];this.querySelectorAll('[data-photo]').forEach(t=>t.setAttribute('aria-pressed',String(t===b)));};});
   this.dialog.showModal();document.body.style.overflow='hidden';
  }
  disconnectedCallback(){this.ro?.disconnect();this.abort?.abort();if(this.dialog?.open){this.dialog.close();document.body.style.overflow=this.bodyOverflow;}this.ready=false;this.stage?.replaceChildren();this.window?.replaceChildren();}
 }
 customElements.define('mt-wrist-reviews',WristReviews);
})();
